import { createApp } from 'vue';

import App from '@/App.vue';
import { registerPlugins } from '@core/utils/plugins';

//ts-ignore
import Uploader from 'vue-media-upload';

// Styles
import '@core/scss/template/index.scss';
import '@styles/styles.scss';
// Single source of truth for all visit-recap surface styling (see src/styles/visitRecap.scss).
import '@/styles/visitRecap.scss';
// Phone shell: --mobile-tabbar-height + safe-area/dvh handling for the bottom tab bar.
import '@styles/mobile-shell.scss';
// Phone shell + installed PWA: native-app feel under `html.app-native` (see useNativeAppMode).
import '@styles/native-app.scss';
import { GetPermission } from './api/authApi';
import { hideBootSplash } from '@/utils/bootSplash';

/**
 * Last-resort cap on the boot splash. The layouts remove it as soon as a shell mounts; this only
 * matters if none ever does (a thrown bootstrap, a route with no layout), so the cat can never
 * hide a broken app forever.
 */
const BOOT_SPLASH_MAX_MS = 20_000;

async function bootstrap() {
  // Create vue app
  const app = createApp(App)
  app.component('Uploader', Uploader);

  // Register plugins before loading auth-dependent data
  registerPlugins(app)

  // Mount vue app
  app.mount('#app')

  GetPermission().catch((error) => {
    console.warn("Permission refresh failed after app mount", error)
  })
}

window.setTimeout(hideBootSplash, BOOT_SPLASH_MAX_MS)

bootstrap().catch((error) => {
  console.error("App bootstrap failed", error)
  hideBootSplash()
})
